<template>
  <div class="manicuristas-crud">
    <h1>Gestión de Manicuristas</h1>
    <form @submit.prevent="saveManicurista">
      <input type="hidden" v-model="manicurista.id">
      <input type="text" v-model="manicurista.nombre" placeholder="Nombre de la Manicurista" required>
      <input type="number" v-model="manicurista.telegram_user_id" placeholder="ID de Usuario de Telegram">
      <label>
        <input type="checkbox" v-model="manicurista.activa"> Activa
      </label>
      <button type="submit">Guardar</button>
      <button type="button" @click="clearForm" v-if="manicurista.id">Cancelar Edición</button>
    </form>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Nombre</th>
          <th>ID Telegram</th>
          <th>Activa</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="mani in manicuristas" :key="mani.id">
          <td>{{ mani.id }}</td>
          <td>{{ mani.nombre }}</td>
          <td>{{ mani.telegram_user_id }}</td>
          <td>{{ mani.activa ? 'Sí' : 'No' }}</td>
          <td>
            <button @click="editManicurista(mani)">Editar</button>
            <button @click="deleteManicurista(mani.id)">Eliminar</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ManicuristasCRUD',
  data() {
    return {
      manicurista: {
        id: null,
        nombre: '',
        telegram_user_id: null,
        activa: true,
      },
      manicuristas: [],
    };
  },
  created() {
    this.fetchManicuristas();
  },
  methods: {
    async fetchManicuristas() {
      try {
        const response = await axios.get('/api/manicuristas');
        this.manicuristas = response.data;
      } catch (error) {
        console.error('Error fetching manicuristas:', error);
      }
    },
    async saveManicurista() {
      try {
        if (this.manicurista.id) {
          await axios.put(`/api/manicuristas/${this.manicurista.id}`, this.manicurista);
        } else {
          await axios.post('/api/manicuristas', this.manicurista);
        }
        this.clearForm();
        this.fetchManicuristas();
      } catch (error) {
        console.error('Error saving manicurista:', error);
      }
    },
    editManicurista(manicurista) {
      this.manicurista = { ...manicurista };
    },
    async deleteManicurista(id) {
      if (confirm('¿Estás seguro de que quieres eliminar esta manicurista?')) {
        try {
          await axios.delete(`/api/manicuristas/${id}`);
          this.fetchManicuristas();
        } catch (error) {
          console.error('Error deleting manicurista:', error);
        }
      }
    },
    clearForm() {
      this.manicurista = {
        id: null,
        nombre: '',
        telegram_user_id: null,
        activa: true,
      };
    },
  },
};
</script>

<style scoped>
.manicuristas-crud {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

input[type="text"], input[type="number"], button {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

button {
  background-color: #42b983;
  color: white;
  cursor: pointer;
}

button:hover {
  background-color: #369f75;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}
</style>
